// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { connectedApplicationsResponseSchema } from '@/account/api/get-connected-applications';
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';

/** Signs the signed-in person out of one session with a connected application. */
export async function signOutConnectedApplicationSession(
  applicationKey: string,
  sessionId: string
) {
  const path = `/v1/connected-application/${applicationKey}/session/${sessionId}`;
  const response = await api.delete(path);

  return parseResponse(connectedApplicationsResponseSchema, response.data, {
    schemaName: 'SignOutConnectedApplicationSession',
    endpoint: path,
  });
}
